require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./using-font-awesome-5-with-turbolinks-and-stimulus.json") })
        }
      }, "path---using-font-awesome-5-with-turbolinks-and-stimulus");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---using-font-awesome-5-with-turbolinks-and-stimulus!./.cache/json/using-font-awesome-5-with-turbolinks-and-stimulus.json
// module id = 332
// module chunks = 231608221292675